import { BoschUiPageEvent } from './bosch-ui-paginator.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { MAX_VISIBLE_PAGES } from './bosch-ui-paginator.constants';

export interface BoschUiPaginatorInterface {
  set totalElements(totalElements: number);

  set pageSize(pageSize: number);

  set pageNumber(pageNumber: number);

  page$: Observable<BoschUiPageEvent>;

  nextPage(): void;

  previousPage(): void;

  firstPage(): void;

  lastPage(): void;
}

export class BoschUiPaginatorBase implements BoschUiPaginatorInterface {
  set totalElements(totalElements: number) {
    this.paginatorState = {
      ...this.paginatorState,
      totalElements,
    };
  }

  set pageSize(pageSize: number) {
    this.paginatorState = {
      ...this.paginatorState,
      pageSize,
    };
  }

  set pageNumber(pageNumber: number) {
    this.paginatorState = {
      ...this.paginatorState,
      pageNumber,
    };
  }

  protected paginatorState: BoschUiPageEvent = {
    totalElements: 0,
    pageNumber: 0,
    previousPageNumber: 0,
    pageSize: 0,
  };
  protected totalElements$ = new BehaviorSubject<number>(0);
  protected pageNumber$ = new BehaviorSubject<number>(0);
  protected pageSize$ = new BehaviorSubject<number>(0);
  protected maxVisiblePages$ = new BehaviorSubject<number>(MAX_VISIBLE_PAGES);

  page$ = new BehaviorSubject<BoschUiPageEvent>(this.paginatorState);

  nextPage(): void {
    const pageNumber = this.paginatorState.pageNumber;

    if (pageNumber < this.paginatorState.totalElements) {
      this.pageNumber$.next(pageNumber + 1);
    }
  }

  previousPage(): void {
    const pageNumber = this.paginatorState.pageNumber;

    if (pageNumber > 0) {
      this.pageNumber$.next(pageNumber - 1);
    }
  }

  firstPage(): void {
    this.pageNumber$.next(0);
  }

  lastPage(): void {
    const totalPages = this.getTotalPages(this.paginatorState.totalElements, this.paginatorState.pageSize);

    this.pageNumber$.next(totalPages);
  }

  protected getTotalPages(totalElements: number, pageSize: number): number {
    return Math.ceil(totalElements / pageSize);
  }
}
